import 'angular';

export function PROLinkInvoices ($timeout, $state, $window, $translate, API, workshopAPI, sessionObjAPI, confirm, messages, staticLookup) {
  var PROLinkInvoices = function (invoice, vehicle) {
    this.origin = sessionObjAPI.base().origin;
    this.Invoice = invoice;
    this.vehicle = vehicle || {};
  };

  PROLinkInvoices.prototype.hookUrl = function() {
    var self = this;

    return self.Invoice.invoice.vehicle_id ?
    `${self.origin}workshop.html#/${self.Invoice.invoice.customer_id}/${self.Invoice.invoice.vehicle_id}/invoice/${self.Invoice.invoice.id}`:
    `${self.origin}workshop.html#/${self.Invoice.invoice.customer_id}/invoice/${self.Invoice.invoice.id}`;
  };

  PROLinkInvoices.prototype.buildQueryString = function() {
    var self = this;
    var queryString = {
      hookUrl: self.hookUrl(),
      type: 'inquiry',
      invoice_id: self.Invoice.invoice.id
    };

    if (self.vehicle.id) {
      let vehicle = angular.copy(self.vehicle);

      delete vehicle.follow_up_comment;

      queryString.vehicleInfo = angular.toJson(vehicle);

      queryString['NEW_ITEM-CUST_FIELD5[1]'] = self.vehicle.prolink_vehicle_id;
      queryString['NEW_ITEM-CUST_FIELD6[1]'] = self.vehicle.make;
      queryString['NEW_ITEM-CUST_FIELD7[1]'] = self.vehicle.model;
    }

    queryString['HOOKURL'] = `${API.url}/invoices/add_item_from_prolink/${self.Invoice.invoice.id}`;

    return $.param(queryString);
  };

  PROLinkInvoices.prototype.hasSku = function(item) {
    var self = this;

    if (item) {
      return item.prolink_sku;
    }

    var items = self.Invoice.invoice.invoice_items_attributes.filter(function (item) {
      return item.prolink_sku;
    });

    return items.length > 0;
  };

  PROLinkInvoices.prototype.addItems = function() {
    var self = this;

    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', {name:"PROLink"}), null, 'prolinkInvoicesAutoSave')
    .then(function () {
      return self.Invoice.save();
    }).then(function (invoice) {
      $timeout(function () {
        $window.location.assign(`prolink.html?${self.buildQueryString()}`);
      });
    });
  };

  PROLinkInvoices.prototype.addToOrder = function() {
    var self = this;

    self.Invoice.save().then(function (invoice) {
      var params = [ sessionObjAPI.company().prolink_settings.prolink_vendor_id, 0, '*', 'S', 'order_date', 'desc' ];

      self.Invoice.invoice = invoice;

      return workshopAPI.get('/vendors/purchase_order_list', params);

    }).then(function (orders) {
      if (orders.length > 1) {
        return staticLookup(orders, {
          columns: [
            {
              field : 'order_number',
              header: {
                text: $translate.instant('PURCHASE_ORDER_SPACE.ORDER_NUMBER')
              }
            },
            {
              field : 'order_date',
              header: {
                text: $translate.instant('GENERAL_SPACE.FIELD.DATE'),
              },
              pipe: 'globalDate'
            },
            {
              classes: [ 'text-center' ],
              field  : 'total',
              header : {
                classes: [ 'text-center' ],
                text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT'),
              },
              pipe: 'globalCurrency',
            }
          ]
        }).then(function (order) {
          return workshopAPI.get('/invoice/create_prolink_order', [self.Invoice.invoice.id, order.id]);
        });
      }
      else if (orders.length === 1) {
        var message = $translate.instant('JS_SPACE.INTEGRATIONS.STOCK_ORDER_OPEN', {name:"PROLink", num:orders[0].order_number});
        return confirm.custom( {
          message: message,
          buttons: {
            new: {
              title: $translate.instant('JS_SPACE.INTEGRATIONS.NEW_ORDER'),
              class: 'primary'
            },
            existing: {
              title: $translate.instant('MENU_SPACE.ADD_TO_ORDER'),
              class: 'success'
            }
          }
        }).then(function (answer) {
          return workshopAPI.get('/invoice/create_prolink_order', [self.Invoice.invoice.id, (answer === 'new' ? answer: orders[0].id) ] );
        });
      }
      else {
        return confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.CREATE_ORDER', {name:"PROLink"}))
        .then(function () {
          return workshopAPI.get('/invoice/create_prolink_order', [self.Invoice.invoice.id, 'new'] );
        });
      }
    }).then(function (order) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.ITEMS_ADDED_TO_ORDER'), 'success');
      $state.go('app.purchase-order', {
        vendor_id: sessionObjAPI.company().prolink_settings.prolink_vendor_id,
        id       : order.purchase_order_id
      });
    }, function (err) {
      messages.error(err);
    });
  };

  return PROLinkInvoices;
}